'use client';

import { ReactElement } from 'react';
import { InfoFootnote } from '../InfoFootnote/InfoFootnote';
import { RequestActionArea, type RequestActionAreaProps } from './RequestActionArea';

export type RequestPageEndProps = RequestActionAreaProps & {
  /** Why the request limits the choice. An empty note, or one of spaces only, counts as none. */
  limitNote: string | undefined;
};

/**
 * The end of the choose page: the action area and, when there is a note, the footer. On a desktop
 * the footer is under the action row. On a phone the sticky bar is the last thing in the page, so
 * the footer comes before it and scrolls clear of the bar. The parts are direct children of the
 * page, so the page's own spacing applies to them.
 */
export function RequestPageEnd({
  limitNote,
  ...actionAreaProps
}: Readonly<RequestPageEndProps>): ReactElement {
  const note = limitNote?.trim();
  const footer = note ? <InfoFootnote>{note}</InfoFootnote> : null;
  const actions = <RequestActionArea {...actionAreaProps} />;

  return actionAreaProps.layout === 'phone' ? (
    <>
      {footer}
      {actions}
    </>
  ) : (
    <>
      {actions}
      {footer}
    </>
  );
}
